<ng-container *ngIf="covertVaccCounterToArr.length == 1">
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[0]"></JSB-flipclock-template>
</ng-container>
<ng-container *ngIf="covertVaccCounterToArr.length == 2">
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[0]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[1]"></JSB-flipclock-template>
</ng-container>
<ng-container *ngIf="covertVaccCounterToArr.length == 3">
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[0]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[1]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[2]"></JSB-flipclock-template>
</ng-container>
<ng-container *ngIf="covertVaccCounterToArr.length == 4">
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[0]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[1]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[2]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[3]"></JSB-flipclock-template>
</ng-container>
<ng-container *ngIf="covertVaccCounterToArr.length == 5">
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[0]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[1]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[2]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[3]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[4]"></JSB-flipclock-template>
</ng-container>
<ng-container *ngIf="covertVaccCounterToArr.length == 6">
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[0]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[1]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[2]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[3]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[4]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[5]"></JSB-flipclock-template>
</ng-container>
<ng-container *ngIf="covertVaccCounterToArr.length == 7">
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[0]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[1]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[2]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[3]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[4]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[5]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[6]"></JSB-flipclock-template>
</ng-container>
<ng-container *ngIf="covertVaccCounterToArr.length == 8">
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[0]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[1]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[2]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[3]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[4]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[5]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[6]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[7]"></JSB-flipclock-template>
</ng-container>
<ng-container *ngIf="covertVaccCounterToArr.length == 9">
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[0]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[1]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[2]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[3]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[4]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[5]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[6]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[7]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[8]"></JSB-flipclock-template>
</ng-container>
<ng-container *ngIf="covertVaccCounterToArr.length == 10">
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[0]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[1]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[2]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[3]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[4]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[5]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[6]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[7]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[8]"></JSB-flipclock-template>
  <JSB-flipclock-template  [value]="covertVaccCounterToArr[9]"></JSB-flipclock-template>
</ng-container>



